import storyblokRuntime_36N0HyrOOFm8Lxpb2UgbsHUXsbxGCI_453cvl7G0aRPj2dM from '/usr/src/app/node_modules/@nuxt/image/dist/runtime/providers/storyblok'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536,"phone":420,"tablet-portrait":600,"tablet-landscape":900,"desktop":1200,"big-desktop":1800},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"storyblok"} */
  provider: "storyblok",
  providers: {
      ['storyblok']: { setup: storyblokRuntime_36N0HyrOOFm8Lxpb2UgbsHUXsbxGCI_453cvl7G0aRPj2dM, defaults: {"baseURL":"https://a.storyblok.com","modifiers":{"format":"webp"}} }
  }
}
